
  import StarRating from '@/mixins/StarRating';
  export default {
    name: 'StarRatingActionButtonV2',
    mixins: [StarRating],
  };
